/* eslint-disable jsx-a11y/no-redundant-roles */
import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { TabStyles } from '../styles/TabStyles';

const { Colors } = TabStyles;

const DividerStyleName = TypeStyle.style({
  border: 'none',
  borderTop: `1px solid ${Colors.L3}`,
  margin: '8px 0',
});

export const MenuDividerWidget: React.FunctionComponent = () =>
  <hr aria-orientation='horizontal' className={DividerStyleName} role='separator' />;
MenuDividerWidget.displayName = 'MenuDividerWidget';
